/**
 * Page-load timing context — collects per-component "data ready" reports so the
 * PageTimingProvider can assemble one drill-down record per page load.
 *
 * Design: docs/FeatureDesigns/page-load-perf-drilldown.md
 */

import { createContext, useContext } from 'react';

export interface PageTimingContextValue {
  /** A block reports when its own data has settled: (name, mount→settle ms, fromCache). */
  report: (name: string, ms: number, fromCache: boolean) => void;
  /** True only inside a PageTimingProvider — lets useComponentTiming no-op elsewhere. */
  active: boolean;
  /** Normalized route label for the current page, so `useActionTiming` can file
   *  an action under the same label the page's own load samples use. Empty when
   *  no provider is mounted. */
  page: string;
}

const noop = () => { /* no provider mounted → drop the report */ };

export const PageTimingContext = createContext<PageTimingContextValue>({ report: noop, active: false, page: '' });

export const usePageTimingReport = (): PageTimingContextValue => useContext(PageTimingContext);
